module.exports = __webpack_public_path__ + "img/image1.88d6e9e2.jpg";